type grid = boolean[][];

export const rotateGridClockwise = (grid: grid): grid => {
  return grid[0].map((_, index) => grid.map(row => row[index]).reverse());
};

export const rotateGridCounterClockwise = (grid: grid): grid => {
  return grid[0].map((_, index) =>
    grid.map(row => row[grid[0].length - index - 1]),
  );
};

export const flipGridVertically = (grid: grid): grid => {
  return grid.reverse();
};

export const flipGridHorizontally = (grid: grid): grid => {
  return grid.map(row => row.reverse());
};
